// extracted by mini-css-extract-plugin
module.exports = {"flexItem":"_1J_9o","flexCenter":"o-XY7","flexStart":"_3UMoO","flexEnd":"_1Tsxx","flexAround":"_3E7D_","flexEvenly":"_2SaNa","flexBetween":"KMM5g","alignCenter":"_2sHvy"};